import React, { useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { ItemOfertaData } from '../../../types';

interface PricingFieldsProps {
  currentItem: ItemOfertaData;
  itemIndex: number;
  handleItemChange: (field: keyof ItemOfertaData, value: string | number) => void;
  shouldValidate: boolean;
}

/** Máximo 2 decimales en la parte fraccional (sin contar punto final al escribir) */
const PRECIO_BRUTO_INPUT_PATTERN = /^\d*\.?\d{0,2}$/;

/** Permite entrada decimal estable; el estado numérico redondeaba "10." a 10 en cada tecla */
function parsePrecioBrutoInput (raw: string): number | null {
  if (raw === '' || raw === '.') return 0;
  const n = Number.parseFloat(raw);
  if (Number.isNaN(n)) return null;
  return Math.round(n * 100) / 100;
}

export const PricingFields: React.FC<PricingFieldsProps> = ({
  currentItem,
  itemIndex,
  handleItemChange,
  shouldValidate,
}) => {
  const [precioBrutoDraft, setPrecioBrutoDraft] = useState<string | null>(null);

  const precioBrutoDisplay =
    precioBrutoDraft ?? String(currentItem.precio_bruto);

  const updatePrecioBrutoFromInput = (rawInput: string) => {
    const normalized = rawInput.replace(',', '.');
    if (normalized !== '' && !PRECIO_BRUTO_INPUT_PATTERN.test(normalized)) return;
    setPrecioBrutoDraft(normalized);
    const parsed = parsePrecioBrutoInput(normalized);
    if (parsed !== null) {
      handleItemChange('precio_bruto', parsed);
    }
  };

  return (
    <>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          id={`grossAmount-${itemIndex}`}
          label="Precio Bruto"
          fullWidth
          slotProps={{ htmlInput: { inputMode: 'decimal' } }}
          value={precioBrutoDisplay}
          onFocus={() => {
            setPrecioBrutoDraft(String(currentItem.precio_bruto));
          }}
          onChange={(e) => updatePrecioBrutoFromInput(e.target.value)}
          onBlur={() => {
            setPrecioBrutoDraft(null);
          }}
          required={shouldValidate}
          error={shouldValidate && (!currentItem.precio_bruto || currentItem.precio_bruto <= 0)}
          helperText={shouldValidate && (!currentItem.precio_bruto || currentItem.precio_bruto <= 0) ? 'Campo requerido' : ''}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          label="Descuento (%)"
          fullWidth
          value={currentItem.descuento}
          onChange={(e) =>
            handleItemChange('descuento', Number(e.target.value) || 0)
          }
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          label="Precio Neto"
          fullWidth
          value={currentItem.precio_neto}
          disabled
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          label="Precio Neto * Unidades"
          fullWidth
          value={currentItem.precio_total}
          disabled
          sx={{ display: 'none' }}
        />
      </Grid>
    </>
  );
};

